'use strict';

module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];



//////////////////
// WEBPACK FOOTER
// ./~/dibs-currency-helpers/currencies.js
// module id = 1473
// module chunks = 64